import HasMoreMutator from '../../boilerplate/redux/mutators/PagingMetadataMutator';

const reduxPipeline = {
  'hasmore': HasMoreMutator,
};

export default reduxPipeline;
